export default "__VITE_ASSET__i8KD0yfw__"